(function () {
  "use strict";

  if (window.PartifyCollectionHierarchy) {
    window.PartifyCollectionHierarchy.refresh();
    return;
  }

  const CATEGORY = "filter.p.m.custom.collection_types";
  const SUBTYPE = "filter.p.m.custom.collection_subtypes_list";
  const PRODUCT_TYPE = "filter.p.product_type";
  const LEVELS = [CATEGORY, SUBTYPE, PRODUCT_TYPE];

  function clearBelow(url, level) {
    LEVELS.slice(LEVELS.indexOf(level) + 1).forEach((key) => url.searchParams.delete(key));
    url.searchParams.delete("page");
    url.hash = "";
    return url;
  }

  function selectUrl(level, value, source = window.location.href) {
    const url = new URL(source, window.location.href);
    clearBelow(url, level);
    ["damage", "damage_area", "damage_type"].forEach((key) => url.searchParams.delete(key));
    url.searchParams.delete(level);
    if (value !== null) url.searchParams.set(level, value);
    return url;
  }

  function filterUrl(source) {
    if (window.PartifyCollectionDamage?.isActive() || window.PartifyCollectionDamage?.isBrowsingAll()) return window.PartifyCollectionDamage.filterUrl(source);
    const current = new URL(window.location.href);
    const url = new URL(source, current);
    for (const level of LEVELS) {
      const before = current.searchParams.getAll(level).sort().join("\u0000");
      const after = url.searchParams.getAll(level).sort().join("\u0000");
      if (before !== after) return clearBelow(url, level);
    }
    url.searchParams.delete("page");
    return url;
  }

  function breadcrumbs() {
    const nav = document.getElementById("collection-breadcrumbs");
    if (window.PartifyCollectionDamage?.isActive()) {
      if (nav) nav.hidden = true;
      return;
    }
    const list = document.getElementById("breadcrumbs-list");
    const current = new URL(window.location.href);
    const labels = new Map();
    if (nav) nav.querySelectorAll("[data-hierarchy-label]").forEach((node) => {
      labels.set(node.dataset.param + "\u0000" + node.dataset.value, node.dataset.label);
    });
    const supportsSubtypes = (nav || document.getElementById("collection-auto-parts-section"))?.dataset.subtypesEnabled === "true";
    const levels = LEVELS.filter((level) => level !== SUBTYPE || supportsSubtypes);
    const selected = levels.filter((level) => current.searchParams.has(level));
    const title = document.querySelector(".collection-title");
    if (title) {
      if (!title.dataset.hierarchyBaseTitle) title.dataset.hierarchyBaseTitle = title.textContent.trim();
      const last = selected[selected.length - 1];
      const label = last ? current.searchParams.getAll(last).map((value) => labels.get(last + "\u0000" + value) || value).join(", ") : "";
      title.textContent = title.dataset.hierarchyBaseTitle + (label ? " - " + label : "");
    }
    if (!nav || !list) return;
    list.replaceChildren();

    function append(label, url) {
      const item = document.createElement("li");
      item.className = "breadcrumb-item";
      if (list.children.length) {
        const separator = document.createElement("span");
        separator.className = "breadcrumb-separator";
        separator.setAttribute("aria-hidden", "true");
        separator.textContent = ">";
        item.append(separator);
      }
      const text = document.createElement(url ? "a" : "span");
      text.className = url ? "breadcrumb-link" : "breadcrumb-current";
      text.textContent = label;
      if (url) text.href = url.href;
      else text.setAttribute("aria-current", "page");
      item.append(text);
      list.append(item);
    }

    if (selected.length) {
      const base = new URL(current);
      LEVELS.forEach((level) => base.searchParams.delete(level));
      base.searchParams.delete("page");
      base.hash = "";
      append(nav.dataset.collectionTitle, base);
    }
    selected.forEach((level, index) => {
      const label = current.searchParams.getAll(level).map((value) => labels.get(level + "\u0000" + value) || value).join(", ");
      append(label, index < selected.length - 1 ? clearBelow(new URL(current), level) : null);
    });
    nav.hidden = selected.length === 0;

  }

  function refresh() {
    document.querySelectorAll("[data-hierarchy-param][data-hierarchy-value]").forEach((link) => {
      link.href = selectUrl(link.dataset.hierarchyParam, link.dataset.hierarchyValue).href;
    });
    document.querySelectorAll("a[data-filter-input]").forEach((link) => {
      const url = new URL(link.href, window.location.href);
      if (url.origin === window.location.origin && url.pathname === window.location.pathname) {
        link.href = filterUrl(url.href).href;
      }
    });
    breadcrumbs();
    const url = new URL(window.location.href);
    const category = document.getElementById("collection-auto-parts-section");
    const legacyCategory = document.getElementById("collection-category-id");
    const categoryRoot = category || legacyCategory;
    const supportsSubtypes = categoryRoot?.dataset.subtypesEnabled === "true";
    const hasHierarchy = LEVELS.some((level) => (level !== SUBTYPE || supportsSubtypes) && url.searchParams.has(level));
    const hasCategories = categoryRoot && categoryRoot.querySelector("[data-hierarchy-param]");
    if (categoryRoot) categoryRoot.hidden = hasHierarchy || url.searchParams.has("filter.p.m.custom.vehicle_areas") || !hasCategories;
    const grid = document.querySelector("[data-productgrid-outer]");
    if (grid && /\/collections\/\d{4}-/.test(url.pathname)) {
      const hasFilters = [...url.searchParams.keys()].some((key) => key.startsWith("filter."));
      grid.style.display = !hasFilters && hasCategories && !window.PartifyCollectionDamage?.isBrowsingAll() ? "none" : "";
    }
  }

  document.addEventListener("click", function (event) {
    const tile = event.target.closest("a[data-hierarchy-param][data-hierarchy-value]");
    if (tile) tile.href = selectUrl(tile.dataset.hierarchyParam, tile.dataset.hierarchyValue).href;
    const link = event.target.closest("a[data-filter-input]");
    if (!link || link.hasAttribute("data-disabled") || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (!document.querySelector("[data-collection-hierarchy]")) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(filterUrl(url.href).href);
  }, true);

  document.addEventListener("shopify:section:load", refresh);
  window.addEventListener("popstate", refresh);
  window.PartifyCollectionHierarchy = { refresh, selectUrl, filterUrl };
  refresh();
})();
